module.exports = __webpack_public_path__ + "static/media/snapcode.7085fe26.svg";